import axios from "@/api/axiosInstance";
import { ArchiveDiagnosticAttemptResponse } from "./types";
import type { CoachAttemptDetail } from "../../types/diagnostic";

/**
 * Archive or restore an attempt.
 *
 * Archiving is reversible and never deletes: the attempt keeps its answers and
 * audit trail, it just drops out of the default history view.
 */
export const archiveDiagnosticAttempt = async (
  attemptId: number,
  archived: boolean,
): Promise<CoachAttemptDetail> => {
  const response = await axios.post<ArchiveDiagnosticAttemptResponse>(
    `/api/private/attempts/${attemptId}/archive`,
    { archived },
  );
  return response.data.data;
};
